import React from "react";
import WorkingPart from "../../../components/user/workingPartSnap/workingPartFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const HomePage = () => {
  return (
    <Layout
      body={
        <>
          <WorkingPart />
        </>
      }
    />
  );
};

HomePage.propTypes = {};

export default HomePage;
